import settings from 'src/features/settingsByApollo';
import phoneService from 'src/utils/phone';
import cacheService from 'src/utils/cache';
import { RESET_CUSTOMER } from 'src/store/modules/customer';
import { RESET_USER } from 'src/store/modules/user';

const tokenType = {
  JWT_OPERATOR: 'jwt_operator',
  JWT_OVERSEER: 'jwt_overseer',
  JWT_ADMIN: 'jwt_ent_admin',
  JWT_CUSTOMER: 'jwt_customer',
};

export default {
  tokenType,
  getTokenName(role) {
    switch (role) {
      case 'operator':
        return tokenType.JWT_OPERATOR;
      case 'overseer':
        return tokenType.JWT_OVERSEER;
      case 'team':
        return tokenType.JWT_OVERSEER;
      case 'ent_admin':
        return tokenType.JWT_ADMIN;
      case 'customer':
        return tokenType.JWT_CUSTOMER;
      default:
        break;
    }
    return '';
  },
  clearAndSetStorage(token, role) {
    const jwtRole = this.getTokenName(role);
    this.clearStorage(jwtRole);
    localStorage.setItem(jwtRole, token);
  },
  clearStorage(token) {
    if (token !== tokenType.JWT_CUSTOMER) window.$store.commit(`user/${RESET_USER}`);
    else window.$store.commit(`customer/${RESET_CUSTOMER}`);
    this.removeTokenByRole(token);
    phoneService.remove();
    cacheService.clear();
  },
  setRoleToken(role, token) {
    const newRole = this.getTokenName(role);
    localStorage.setItem(newRole, token);
  },
  getToken(token) {
    return localStorage.getItem(token)
      ? localStorage.getItem(token) : null;
  },
  getCurrentToken() {
    const token = settings.getCurrentToken();
    return localStorage.getItem(token)
      ? localStorage.getItem(token) : null;
  },
  removeTokenByRole(roleToken) {
    localStorage.removeItem(roleToken);
  },
};
